import { render } from "./FamilyIncomeBenefitAnalysis.vue?vue&type=template&id=3f16f84a&scoped=true"
import script from "./FamilyIncomeBenefitAnalysis.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitAnalysis.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitAnalysis.vue?vue&type=style&index=0&id=3f16f84a&lang=css"
import "./FamilyIncomeBenefitAnalysis.vue?vue&type=style&index=1&id=3f16f84a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f16f84a"]])

export default __exports__